var _a, _b;
import { TABLET_WIDTH } from "@codex/utils/constants";
import { SMALL_LAPTOP_WIDTH } from "@codex/utils/constants";
var styles = (_a = {
        group: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: 69,
            alignItems: 'center'
        },
        gropTitle: {
            width: 57,
            height: 22,
            fontFamily: 'Assistant Semi Bold',
            fontSize: 28,
            fontWeight: 600,
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 0.79,
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#2c3e50',
            marginTop: 31,
            marginBottom: 0,
        },
        groupSubTitle: {
            width: 265,
            height: 26,
            fontFamily: 'Assistant',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 1.08,
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#5a5a6c',
            marginTop: 20
        }
    },
    _a["@media screen and (max-width:" + TABLET_WIDTH + "px)"] = {
        groups: {
            height: 333,
            marginTop: 30,
        },
        group: {
            marginTop: 0,
            marginBottom: 10,
        },
        gropTitle: {
            width: 'auto',
            fontFamily: 'Assistant Semi Bold',
            marginTop: 11,
            fontSize: 20,
            fontWeight: 600,
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 1.1,
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#2c3e50',
        },
        groupSubTitle: {
            width: 'auto',
            fontFamily: 'Assistant',
            fontSize: 15,
            marginTop: 6,
            marginBottom: 0,
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 1.2,
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#5a5a6c',
        },
    },
    _a["@media screen and (min-width: " + TABLET_WIDTH + "px) and (max-width:" + SMALL_LAPTOP_WIDTH + "px)"] = {
        group: (_b = {},
            _b['& img'] = {
                width: 90,
                height: 80,
            },
            _b),
        gropTitle: {
            fontSize: 24,
        },
        groupSubTitle: {
            fontSize: 18,
        }
    },
    _a);
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/components/Group/styles.ts
// module id = 1353
// module chunks = 0